<template>
  <b-card class="card-shadow mb-4" no-body>
    <b-card-body>
      <b-form class="mb-3" inline>
        <label class="h4 mr-2">Porovnanie:</label>
        <b-form-select
          v-model="$parent.value"
          :select-size="1"
          @change="chartUpdate"
        >
          <option
            v-for="(val, key) in $parent.chartValues"
            :key="key"
            :value="key"
          >
            {{ val.title }}
          </option>
        </b-form-select>
      </b-form>
      <b-row>
        <b-col v-if="monthlyData" md="8">
          <chart ref="monthchart" :options="chartOptionsM" />
        </b-col>
        <b-col md="4">
          <chart ref="yearchart" :options="chartOptionsY" />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>
<script>
import { Chart } from 'highcharts-vue'

export default {
  components: {
    Chart,
  },
  props: ['data'],
  data: function () {
    return {
      loading: false,
      chartOptionsM: {
        chart: {
          height: 350,
        },
        title: {
          text: 'Mesačné porovnanie',
        },
        xAxis: {
          categories: {},
        },
        yAxis: {
          title: {
            text: '',
          },
        },
        tooltip: {
          shared: true,
          crosshairs: true,
          valueDecimals: null,
          valueSuffix: ' ',
        },
        series: [],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ['downloadPNG', 'downloadPDF'],
            },
          },
          filename: 'fakturacne-data_mesacny-report',
        },
        legend: {
          reversed: true,
        },
      },
      chartOptionsY: {
        chart: {
          height: 250,
        },
        title: {
          text: 'Ročné porovnanie',
        },
        xAxis: {
          categories: {},
          reversed: true,
        },
        yAxis: {
          title: {
            text: '',
          },
        },
        tooltip: {
          shared: true,
          crosshairs: true,
          valueDecimals: null,
          valueSuffix: ' ',
        },
        series: [],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ['downloadPNG', 'downloadPDF'],
            },
          },
          filename: 'fakturacne-data_rocny-report',
        },
      },
    }
  },
  computed: {
    monthlyData: function () {
      return this.data.filter((item) => {
        return !item.total
      }).length
    },
  },
  created: function () {},
  mounted: function () {
    this.chartOptionsM.xAxis.categories = this.$helpers.monthsSk()
    this.chartOptionsY.xAxis.categories = this.data.map((item) => {
      return item.year
    })
    this.chartUpdate()
  },
  methods: {
    chartUpdate: function () {
      this.chartOptionsM.yAxis.title.text =
        this.$parent.chartValues[this.$parent.value].title +
        ' (' +
        this.$parent.chartValues[this.$parent.value].suffix +
        ')'
      this.chartOptionsM.tooltip.valueDecimals =
        this.$parent.chartValues[this.$parent.value].decimal
      this.chartOptionsM.tooltip.valueSuffix =
        ' ' + this.$parent.chartValues[this.$parent.value].suffix

      this.chartOptionsM.series = this.$parent.monthlySeries

      this.chartOptionsY.yAxis.title.text =
        this.$parent.chartValues[this.$parent.value].title +
        ' (' +
        this.$parent.chartValues[this.$parent.value].suffix +
        ')'
      this.chartOptionsY.tooltip.valueDecimals =
        this.$parent.chartValues[this.$parent.value].decimal
      this.chartOptionsY.tooltip.valueSuffix =
        ' ' + this.$parent.chartValues[this.$parent.value].suffix
      this.chartOptionsY.series[0] = {
        showInLegend: false,
        name: this.$parent.chartValues[this.$parent.value].title,
        type: 'column',
        data: this.$parent.yearlySeries,
      }
    },
  },
}
</script>
